export default function init_toolbar(IconsView, iconsViewCache) {

    IconsView.prototype.renderToolbar = function (toolbar, element, toolbarClass, top, formData) {
        const myself = this;
        // read columns
        const buttons = $('<div class="left"></div>');
        const buttonsRight = $('<div class="right"></div>');

        // Fixed tools
        if (top) {
            buttonsRight.append(myself.renderToolbarControl({
                name: 'nextView',
                action: 'setView',
                view: 'next',
                label: "Mode d'affichage",
                icon: 'file-type-img-raw',
            }));

            buttonsRight.append(myself.renderToolbarControl({
                type: 'zoom',
            }));

            if (this.dataMode == 'url') {
                buttonsRight.append(myself.renderToolbarControl({
                    name: 'refresh',
                    action: 'reload',
                    label: 'Actualiser',
                    icon: 'arrow-do-refresh',
                }));
            }
        }

        // Controles
        $.each(toolbar, (indexButton, button) => {
            if (typeof button === 'string') {
                if (myself.options.actions && myself.options.actions[button]) {
                    toolbar[indexButton] = button = myself.options.actions[button];
                } else {
                    delete toolbar[indexButton];
                    button = null;
                }
            }

            if (button) {
                const buttonOutput = myself.renderToolbarControl(button);

                // Append
                if (button.align == 'right' || true) {
                    buttonsRight.append(' ');
                    buttonsRight.append(buttonOutput);
                } else {
                    buttons.append(buttonOutput);
                    buttons.append(' ');
                }
            }
        });

        // Hook
        this.buttonsBar = $('<div class="' + toolbarClass + ' ' + ((top) ? 'iv__toolbar--top' : 'iv__toolbar--bottom') + '"></div>');
        this.buttonsBar.append(buttons);
        this.buttonsBar.append(buttonsRight);
        this.buttonsBar.append('<div class="clear"></div>');

        const toolHook = element.parent().parent().parent().find('.iv__toolhook');
        if (toolHook.length) {
            myself.onUnload(toolHook);
            toolHook.html('');
            toolHook.prepend(this.buttonsBar);
        } else if (top) {
            element.prepend(this.buttonsBar);
        } else {
            element.append(this.buttonsBar);
        }

        // Button Click
        this.buttonsBar.find('button').click(function (event) {
            const button = $(this);
            const toolbar = $(button).closest('.iv__toolbar');
            const plugin = toolbar.data('plugin');
            const grid = plugin.element;
            const icons = grid.find('.iv__item--selected');
            grid.data('plugin').action(button.data('action'), grid);
            event.preventDefault();
        });
        this.buttonsBar.data('plugin', this)


        // restore values
        let inputs = this.buttonsBar.find('input, textarea, select');
        inputs.each(function() {
            let name = $(this).attr('name');
            // je veux vérifier si une valeur est défini dans formData
            if (formData[name]) {
                $(this).val(formData[name]);
            }
        })

        // apply filter
        myself.applyFilter(false, this.buttonsBar);
    }


    IconsView.prototype.renderToolbarControl = function (button) {
        const myself = this;

        const buttonClass = [];
        var buttonIcon = (button.item) ? iconImg(button.item) + ' ' : '';
        if (button.style) buttonClass.push('action--' + button.style);
        else buttonClass.push('action--default');
        if (button.require) buttonClass.push('require-' + button.require);

        // Filter Input
        if (button.type == 'filter') {
            var buttonOutput = $(button.input);
            buttonOutput.data('action', button);
            let buttonOutputInput = buttonOutput.add(buttonOutput.find('select, input, textarea'));
            let buttonOutputInputName = buttonOutputInput.attr('name');
            buttonOutputInput.addClass('filter');
            buttonOutputInput.data('field', button.field);
            buttonOutputInput.data('keepNull', (button.keepNull) ? 1 : 0);
            buttonOutputInput.data('queryNull', (button.queryNull) ? 1 : 0);
            buttonOutputInput.data('like', (button.like) ? 1 : 0);
            const currentVal = this.filters[buttonOutputInput.attr('name')];
            if (currentVal) buttonOutput.val(currentVal.value);
            buttonOutputInput.change(() => {
                myself.applyFilter();
            });
            buttonOutputInput.keyup(() => {
                myself.applyFilter();
            });
            myself.reloadInput = true;
            if (button.label) {
                const buttonLabel = $('<label for="' + buttonOutputInputName + '" class="tool-label">' + button.label + ' : </label>');
                buttonOutput = [buttonLabel, buttonOutput];
            }
        }

        // label
        else if (button.type == 'label') {
            var buttonIcon = myself.renderIconImage('small', button.icon) + ' &nbsp;';
            var buttonOutput = $('<label>' + ((button.icon) ? buttonIcon : '') + button.label + '</label>');
        }

        // zoom
        else if (button.type == 'zoom') {
            var zoomMin = 16;
            var zoomMax = 256;
            var zoomEnabled = true;
            switch (myself.view) {
            case 'thumbnails':
                var zoomMin = 96;
                var zoomMax = 512;
                break;
            case 'icons':
                var zoomMin = 32;
                break;
            case 'mosaic':
                var zoomMin = 48;
                var zoomMax = 128;
                break;
            case 'list':
                var zoomMin = 16;
                var zoomMax = 64;
                break;
            case 'summary':
                var zoomMin = 96;
                var zoomMax = 208;
                break;
            case 'table':
            case 'preview':
            case 'slideshow':
            case 'calendar':
            case 'calendar-week':
            case 'calendar-day':
            case 'tree':
                var zoomEnabled = false;
                break;
            }
            if (zoomEnabled) {
                var buttonOutput = $('<input class="iv__zoom" id="iv__zoom--'+this.uid+'" type="range" min="' + zoomMin + '" max="' + zoomMax + '" step="16" style="width: 200px;">');
                buttonOutput.change(function () {
                    myself.setIconSize($(this).val(), null, 1);
                });
                buttonOutput.on('input', function () {
                    $(this).trigger('change');
                });
            }
        }

        // menu input
        else if (button.type == 'menu') {
            const buttonIconHtml = button.icon ? myself.renderIconImage('small', button.icon) : '';
            var buttonOutput = $('<button class="' + buttonClass.join(' ') + ' ' + ((button.icon) ? 'action' : '') + '">' + ((button.icon) ? buttonIconHtml : button.label) + '</button>');
            buttonOutput.data('action', button);

            buttonOutput.click(function (event) {
                const grid = myself.element;

                const processItems = (items) => {
                    const result = [];
                    $.each(items, (index, item) => {
                        if (typeof item === 'string') {
                            if (myself.options.actions && myself.options.actions[item]) {
                                item = myself.options.actions[item];
                            } else if (item === '-') {
                                result.push('-');
                                return;
                            } else {
                                return;
                            }
                        }

                        if (item) {
                            const menuItem = {
                                name: item.label,
                                icon: item.icon,
                                callback: () => {
                                    myself.action(item, grid);
                                },
                            };
                            if (item.items) {
                                menuItem.items = processItems(item.items);
                            }
                            result.push(menuItem);
                        }
                    });
                    return result;
                };

                const menuItems = processItems(button.items);

                if (menuItems.length > 0) {
                    myself.createMenu(menuItems, grid);
                }
                event.stopPropagation();
                event.preventDefault();
            });
        }

        // Btn Input
        else {
            var buttonIcon = myself.renderIconImage('small', button.icon);
            var buttonOutput = $('<button class="' + buttonClass.join(' ') + ' ' + ((button.icon) ? 'action' : '') + '" title="' + button.label + '">' + ((button.icon) ? buttonIcon : button.label) + '</button>');
            buttonOutput.data('action', button);
        }

        return buttonOutput;
    }
}
